import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, ref, onMounted, watch } from '@nuxtjs/composition-api';
import { useGlobalRefs } from "~/core/composables/useGlobalRefs";
import HelpersPersist from '~/core/components/helpers/Persist';


export default /*#__PURE__*/_defineComponent({
  __name: 'mobile',
  setup(__props) {

const context = useContext();
const headerVisible = computed(() => context.store.getters['application/driver/headerVisible']);
const user = computed(() => context.store.getters['application/driver/authUser']);
const mainContainer = ref(null);
const globalRefs = useGlobalRefs();
const route = context.route;

onMounted(() => {
    globalRefs.mainContainer = mainContainer.value;
});

watch(route, () => {
    if (mainContainer.value) {
        mainContainer.value.scrollTo(0, 0);
    }
});

return { __sfc: true,context, headerVisible, user, mainContainer, globalRefs, route, HelpersPersist }
}

})